import { useMemo } from 'react';
import { useLocation } from 'react-router';

import { navigation } from '../utils/navigation';

export function useNavigation() {
  const location = useLocation();

  return useMemo(
    function factory() {
      return navigation();
    },
    [location.pathname],
  );
}
